module.exports = __webpack_public_path__ + "images/category_lp/common/Hikakaku_2e55467c1fa7026d512104f7e2b92602.png";